import React, { forwardRef, useEffect, useState } from "react";
import Logo from "../images/bentex-logo.png";
import GoogleLogo from "../images/google_review_image.jpg";
import AwardOne from "../images/award_thenty_two.png";
import AwardTwo from "../images/award_twenty_three.png";
import AwardThree from "../images/award_twenty_four.png";
import AwardFive from "../images/award_thenty_five.png";

const CustomerDetailPdf = forwardRef(({ customer }, ref) => {
    
    const formatDate = (dateString) => {
    if (!dateString) return ""; 
    try {
      const date = new Date(dateString);
      // Check for invalid date
      if (isNaN(date.getTime())) {
        return dateString; 
      }
      return date.toLocaleDateString("en-GB");
    } catch (error) {
      console.error("Could not format date:", dateString, error);
      return dateString; // Return original string on error
    }
  };

    return (
        <div className="customers_pdf_outer" id="pdfLayout">
            <div className="container">
                <div className="customer_pdf">
                    <div className="pdf_header">
                        <img src={Logo} alt="" />
                        <div className="pdf_header_text">
                            <p>
                                CBD Showroom: Suite 513, Level 5, 250 Pitt Street, Sydney 2000
                                Western Sydney: 35A Smith Street, Wentworthville, NSW 2145
                            </p>
                            <p>Ph: 02 9863 6911, Mobile: 0414 984 976 ABN: - 14146359560</p>
                        </div>
                    </div>
                    <div className="pdf_middle_content">
                        <div className="customer_details">
                            <h4>Customer Details</h4>
                            <div className="customer_details_grid">
                                <div className="left">
                                    <p className="customer_name">{customer?.customer_name}</p>
                                    <p className="customer_location">{customer?.address}</p>
                                    <p className="cusomers_email">{customer?.email}</p>
                                    <p className="cusomer_mobile_number">{customer?.mobile}</p>
                                </div>
                                <div className="right">
                                    <p className="date">Date: {formatDate(customer.date)}</p>
                                    <p className="quote_number">Quote No : {customer.quoteNumber}</p>
                                </div>
                            </div>
                            <h4>Quote Details</h4>
                            <div className="quote_details">
                                <table className="pdf_quote_table">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>Quantity</th>
                                            <th>Price $</th>
                                            <th>Amount $</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customer?.items && customer?.items.length > 0 && customer?.items.map((item, key) => (
                                            <tr>
                                                <td>{item?.description}</td>
                                                <td>{item?.quantity}</td>
                                                <td>{item?.price}</td>
                                                <td>{item?.amount}</td>
                                            </tr>
                                        ))}

                                        <tr>
                                            <td colSpan={3}>Net Price</td>

                                            <td><strong>$</strong>{customer.netPrice}</td>
                                        </tr>
                                        {customer.discount > 0 && <tr>
                                            <td colSpan={3}>Discount </td>
                                            
                                            <td><strong>$</strong>{Number(customer.discount)}</td>
                                        </tr>}
                                        
                                    </tbody>
                                    <tfoot>
                                        <td colSpan={3}>Total Amount</td>
                                        <td><strong>$</strong>{customer.totalAmount}</td>
                                    </tfoot>
                                </table>
                            </div>
                          
                           <div className="terms_comments_row" style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
    
    {/* Left: Terms */}
    <div className="terms_conditions" style={{ flex: 1, marginRight: "20px" }}>
        <h4>Terms and Conditions</h4>
        <ul>
            <li>Quote valid for 10 days.</li>
            <li>Includes 10% gst</li>
            <li>This is system generated quote.</li>
        </ul>
    </div>

    {/* Right: Comments */}
    {customer.comments && (
        <div className="comments_section" style={{ flex: 1, border: "1px solid #ccc", padding: "10px", borderRadius: "5px", background: "#f9f9f9" }}>
            <h4>Comments</h4>
            <p>{customer.comments}</p>
        </div>
    )}

</div>



                                                {/* {customer.comments && (
                    <div className="comments_section" style={{ marginTop: "20px" }}>
                        <h4>Comments</h4>
                        <p>{customer.comments}</p>
                    </div>
                    )} */}


                        </div>

                    </div>



                    <div className="pdf_footer">
                        <div className="top_google_logo">
                            <img src={GoogleLogo} alt="" />
                        </div>
                        <div className="award_logos">
                            <div className="logo_item">
                                <img src={AwardOne} alt="" />
                            </div>
                            <div className="logo_item">
                                <img src={AwardTwo} alt="" />
                            </div>
                            <div className="logo_item">
                                <img src={AwardThree} alt="" />
                            </div>
                            <div className="logo_item">
                                <img src={AwardFive} alt="" />
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CustomerDetailPdf;
